import { styled } from "styled-components";

import { colors, LinkButtonV2, Spacer, Text } from "@vericus/cadmus-ui";

import MagnifyingGlass from "@/assets/shared/magnifying-glass.svg";

interface Props {
  /**
   * Callback for when the user intends to clear the filters.
   */
  onClear: () => void;
}

/**
 * Component for when the user has interacted with the filter but the result is nothing
 */
export const NoFilteredPastAssessments = (props: Props) => {
  return (
    <Container>
      <Content>
        <Img src={MagnifyingGlass} alt={"Magnifying glass"} />
        <Spacer spacing={40} />
        <StyledText kind={"headingFour"}>
          No assessments match the current filters
        </StyledText>
        <Spacer spacing={12} />
        <StyledLinkButton
          onClick={() => {
            props.onClear();
          }}
        >
          Clear all
        </StyledLinkButton>
      </Content>
    </Container>
  );
};

const StyledLinkButton = styled(LinkButtonV2)`
  font-size: 16px;
`;

const StyledText = styled(Text)`
  color: #5b6f98;
  word-break: break-all;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 20px;
`;

const Container = styled.div`
  width: 100%;
  height: 420px;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: ${() => colors.grey100};
`;

const Img = styled.img`
  display: block;
  width: 70px;
  margin: 0 auto;
  fill: ${() => colors.grey500};
`;
